import isValidUUID from './isValidUUID';
export default (() => {
  const pathname = window.location.pathname;
  const splitPathname = pathname === null || pathname === void 0 ? void 0 : pathname.split('/');
  const projectsIndex = splitPathname === null || splitPathname === void 0 ? void 0 : splitPathname.indexOf('projects');
  const potentialProjectId = projectsIndex >= 0 ? (splitPathname === null || splitPathname === void 0 ? void 0 : splitPathname[projectsIndex + 1]) || undefined : undefined;
  return isValidUUID(potentialProjectId) ? potentialProjectId : undefined;
});
//# sourceMappingURL=getProjectIdFromUrl.js.map